import { AttributeValue } from "../../../dom-tools/AttributeValue";
import { DateParser } from "../../../date/DateParser";
import { Sorter } from "./Sorter";

export class DateSorter extends Sorter
{
  static readonly type = new AttributeValue( Sorter.sorterType, "date" );

  _sortElements( elements:Element[] )
  {
    let cachedDates = new Map<Element,number>();

    let getDateValue = ( e:Element )=>
    {
      if ( cachedDates.has( e ) )
      {
        return cachedDates.get( e );
      }

      let dateTimeElement = e.querySelector( this.selector ); 

      if ( dateTimeElement == null )
      {
        console.warn( "No date time found:", e );
      } 

      let dateString = dateTimeElement.textContent;
      let dateRange = DateParser.parseInternationalEnglish( dateString );

      let date = dateRange.start;
      
      cachedDates.set( e, date.getTime() );

      return cachedDates.get( e );
    }

    elements.sort(  ( a, b )=> { return getDateValue( a ) - getDateValue( b ); } );
  }

}